import { api } from "~/lib/api";

export const useUserStore = defineStore("userStore", () => {
    const { data, refetch } = useQuery(api.production.verify.use());

    return {
        data,
        refetch,
    };
});
